import { userSliceSignInUser } from './user.signInUser'
import { userSliceSignOutUser } from './user.signOutUser'

export const TasksSliceExtraReducers = {
  userSliceSignInUser,
  userSliceSignOutUser,
}
